import { render, staticRenderFns } from "./Anamnesis.vue?vue&type=template&id=29f31822&"
import script from "./Anamnesis.vue?vue&type=script&lang=js&"
export * from "./Anamnesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports